var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: _vm.rowData.status === 0 ? "录入" : "详情",
        visible: _vm.dialogVisible,
        width: "1340px",
        "show-close": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "content" }, [
        !_vm.rowData.invoiceType
          ? _c("div", { staticClass: "header" }, [
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("客户")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.form.companyName)),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("柜号")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.form.containerNumber)),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("提单号")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.form.mblNo)),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("分单号")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.form.blNo)),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("重量")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.form.weightKgs)),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("材积")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.form.weightCbm)),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("ISF状态")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.isfStatus)),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("柜型")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.form.containertype)),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("清关方式")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.form.clearenceTypeName)),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("派送类型")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.form.pickUpTypeName)),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("目的港")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.form.destinationHarborName)),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("进口商")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(" " + _vm._s(_vm.form.importerName) + " "),
                  _c(
                    "span",
                    {
                      staticClass: "tips",
                      class: !_vm.form.importerPermission
                        ? "tips-owner"
                        : "tips-out",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            !_vm.form.importerPermission ? "内部" : "外部"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "data" },
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                attrs: {
                  data: _vm.tableData.columns,
                  border: "",
                  width: "100%",
                  height: _vm.height,
                  "header-cell-style": _vm.headerStyle,
                  "cell-style": _vm.cellStyle,
                },
                on: {
                  "selection-change": _vm.selectionChange,
                  "sort-change": _vm.sortChange,
                },
              },
              [
                _vm.status === 2
                  ? _c("el-table-column", {
                      attrs: {
                        align: "center",
                        fixed: "left",
                        type: "selection",
                        selectable: _vm.selectable,
                        resizable: "",
                      },
                    })
                  : _vm._e(),
                _vm._l(_vm.tableData.fileds, function (item, index) {
                  return _c(
                    "el-table-column",
                    {
                      key: index,
                      attrs: {
                        align: item.align || "center",
                        "header-align": "center",
                        "show-overflow-tooltip": true,
                        prop: item.filed,
                        label: item.label,
                        width: item.width,
                        formatter: item.formatter,
                        resizable: "",
                        sortable: item.sortable,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.status !== 1 &&
                                item.filed !== "feeNameId" &&
                                item.filed !== "mblSendWayId"
                                  ? _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          "popper-class": "table-pop-input",
                                          disabled: item.filed !== "remark",
                                          placement: "bottom",
                                          width: "180",
                                          "visible-arrow": false,
                                          trigger: "click",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            rows: 5,
                                            placeholder: "请输入内容",
                                          },
                                          model: {
                                            value: scope.row[item.filed],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                item.filed,
                                                $$v
                                              )
                                            },
                                            expression: "scope.row[item.filed]",
                                          },
                                        }),
                                        _c("el-input", {
                                          ref: `${item.filed + scope.$index}`,
                                          refInFor: true,
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            slot: "reference",
                                            id: `${item.filed + scope.$index}`,
                                            placeholder: "请输入",
                                            disabled: item.disabled,
                                            oninput: item.keyup,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onChang(scope.row)
                                            },
                                            focus: function ($event) {
                                              return _vm.inputFocus(
                                                item.filed,
                                                scope.$index
                                              )
                                            },
                                          },
                                          nativeOn: {
                                            keydown: [
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                return _vm.handleTab(
                                                  item.filed,
                                                  scope.$index + 1
                                                )
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "tab",
                                                    9,
                                                    $event.key,
                                                    "Tab"
                                                  )
                                                )
                                                  return null
                                                return _vm.handleTab(
                                                  item.filed,
                                                  scope.$index + 1
                                                )
                                              },
                                            ],
                                            keyup: function ($event) {
                                              return _vm.arrow(
                                                $event,
                                                item.filed,
                                                scope.$index
                                              )
                                            },
                                          },
                                          slot: "reference",
                                          model: {
                                            value: scope.row[item.filed],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                item.filed,
                                                $$v
                                              )
                                            },
                                            expression: "scope.row[item.filed]",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : scope.row.status !== 1 &&
                                    (item.filed === "feeNameId" ||
                                      item.filed === "mblSendWayId")
                                  ? _c(
                                      "el-select",
                                      {
                                        ref: `${item.filed + scope.$index}`,
                                        refInFor: true,
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          id: `${item.filed + scope.$index}`,
                                          filterable: "",
                                          clearable: "",
                                          placeholder: "请选择",
                                          "filter-method": (e) =>
                                            _vm.filterMethod(
                                              e,
                                              item.filed === "feeNameId"
                                                ? _vm.feeOptionsCopy
                                                : _vm.mblOptionsCopy,
                                              scope.row,
                                              item.filed
                                            ),
                                        },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.onBlur(
                                              item.filed,
                                              scope.row,
                                              scope.row[item.filed]
                                            )
                                          },
                                          focus: function ($event) {
                                            return _vm.onFocus(
                                              item.filed,
                                              scope.row,
                                              scope.row[item.filed]
                                            )
                                          },
                                          change: function ($event) {
                                            return _vm.onChange(
                                              item.filed,
                                              scope.row,
                                              scope.row[item.filed]
                                            )
                                          },
                                          keyup: function ($event) {
                                            return _vm.arrow(
                                              $event,
                                              item.filed,
                                              scope.$index
                                            )
                                          },
                                          "visible-change": (e) =>
                                            _vm.visibleChange(e, item.filed),
                                        },
                                        model: {
                                          value: scope.row[item.filed],
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, item.filed, $$v)
                                          },
                                          expression: "scope.row[item.filed]",
                                        },
                                      },
                                      [
                                        scope.row.isSendWay &&
                                        item.filed === "mblSendWayId"
                                          ? _vm._l(
                                              _vm.mblOptions,
                                              function (a) {
                                                return _c("el-option", {
                                                  key: a.value,
                                                  attrs: {
                                                    label: a.label,
                                                    value: a.value,
                                                  },
                                                })
                                              }
                                            )
                                          : item.filed === "feeNameId"
                                          ? _vm._l(
                                              _vm.feeOptions,
                                              function (a) {
                                                return _c("el-option", {
                                                  key: a.value,
                                                  attrs: {
                                                    label: a.label,
                                                    value: a.value,
                                                    disabled: !a.isActived,
                                                  },
                                                })
                                              }
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : _c(
                                      "p",
                                      [
                                        item.filed === "unitPrice" ||
                                        item.filed === "totalAmount" ||
                                        item.filed === "payableUnitPrice" ||
                                        item.filed === "payableTotalAmount"
                                          ? [
                                              _vm._v(
                                                _vm._s(scope.row[item.filed])
                                              ),
                                            ]
                                          : item.filed === "feeNameId"
                                          ? [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("feeName")(
                                                    scope.row[item.filed],
                                                    _vm.that
                                                  )
                                                )
                                              ),
                                            ]
                                          : item.filed === "mblSendWayId"
                                          ? [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("sendWay")(
                                                    scope.row[item.filed],
                                                    _vm.that
                                                  )
                                                )
                                              ),
                                            ]
                                          : [
                                              _vm._v(
                                                _vm._s(scope.row[item.filed])
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _vm.ifFiled(item.filed)
                            ? [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("* "),
                                ]),
                                _vm._v(_vm._s(item.label) + " "),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    2
                  )
                }),
                _c("el-table-column", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    align: "center",
                    fixed: "right",
                    label: "操作",
                    width: "94",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "tab-bt" },
                            [
                              scope.row.status === 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.hedgingRow(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 对冲 ")]
                                  )
                                : _vm._e(),
                              scope.row.status !== 1
                                ? [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/images/const/delete.png"),
                                        title: "删除",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteRow(scope.$index)
                                        },
                                      },
                                    }),
                                  ]
                                : _vm._e(),
                              scope.$index ===
                                _vm.tableData.columns.length - 1 &&
                              scope.row.status !== 1
                                ? _c("i", {
                                    staticClass: "el-icon-circle-plus-outline",
                                    staticStyle: {
                                      "font-size": "16px",
                                      color: "#1258bc",
                                      "margin-left": "10px",
                                    },
                                    attrs: { title: "增加" },
                                    on: { click: _vm.newAdd },
                                  })
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("div", { staticClass: "custom-total flex_c_c" }, [
            _c("div", [
              _vm._v(" 总条数："),
              _c("span", [_vm._v(_vm._s(_vm.tableData.columns.length))]),
            ]),
            _c("div", [
              _vm._v(" 应收合计："),
              _c("span", [
                _vm._v(_vm._s(_vm.receivableTotalAmount.toFixed(2)) + " USD"),
              ]),
            ]),
            _c("div", [
              _vm._v(" 应付合计："),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.payableTotalAmount.toFixed(2)) +
                    " " +
                    _vm._s(
                      _vm.tableData.columns.find((a) => a.payableCurrency)
                        ?.payableCurrency
                    )
                ),
              ]),
            ]),
            _c("div", [
              _vm._v(" 利润："),
              _c("span", [
                _vm._v(
                  _vm._s(
                    (
                      _vm.receivableTotalAmount - _vm.payableTotalAmount
                    ).toFixed(2)
                  ) + " USD"
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "footer-btn" }, [
            _c(
              "span",
              {
                staticClass: "optDocument flex_c_c",
                on: {
                  click: function ($event) {
                    _vm.dialogVisible1 = true
                  },
                },
              },
              [
                _c("i", { staticClass: "el-icon-question" }),
                _vm._v("操作说明 "),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "debounce-click",
                    rawName: "v-debounce-click",
                    value: _vm.ok,
                    expression: "ok",
                  },
                ],
                staticClass: "ok flex_c_c",
              },
              [_vm._v("提交")]
            ),
          ]),
        ]
      ),
      _c("OptDocumentDialog", {
        attrs: { dialogVisible: _vm.dialogVisible1, type: "Receivables" },
        on: {
          ok: function ($event) {
            _vm.dialogVisible1 = false
          },
        },
      }),
      _c("HedgingDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible2,
          editData: _vm.editData,
          feeOptions: _vm.feeOptionsCopy,
          mblOptions: _vm.mblOptionsCopy,
        },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible2 = false
          },
          ok: _vm.ok1,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }